import React, { useEffect, useState } from "react";
import CommonLayout from "../CommonLayout";
import Change_Password_Header from "../../../Assets/change_password_header.png";
import { Button, Form, message, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import PinInput from "../../Common/Components/PinInput";
import { useTranslation } from "react-i18next";
import { updatePin } from "../../../Services/UserProfileServices";
import "./index.css";
import {
  setPhoneNumber,
  setVuaId,
} from "../../../Services/LocalStorageServices";
import { clearTokens } from "../../../Services/TokenStore";
import { Routes } from "../../../Utils/Constants/routes";
import { useHistory } from "react-router-dom";
import { translation } from "../../../i18n/translationConstant";
import {
  LockOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { useFingerprintValidation } from "../../Authentication/FingerprintValidationContext";

const ChangePassword: React.FC = () => {
  const [updatedPin, setUpdatePin] = useState({
    oldPin: "",
    newPin: "",
    confirmNewPin: "",
  });

  const [form] = useForm();
  const { t } = useTranslation();
  const { replace } = useHistory();

  const checkConfirmPassword = (_: any, value: string) => {
    if (
      value &&
      value !== updatedPin.newPin &&
      value.length === 6
    ) {
      return Promise.reject(
        new Error(t("lblPinMatchError"))
      );
    }

    return Promise.resolve();
  };

  const checkNewPassword = (_: any, value: string) => {
    if (
      value &&
      value === updatedPin.oldPin
    ) {
      return Promise.reject(
        new Error(t("lblResetPinError"))
      );
    }

    return Promise.resolve();
  };

  const formSubmit = (values: any) => {
    updatePin(values.oldPin, values.newPin).then(() => {
      form.resetFields();

      message.success(t("lblPinUpdateSuccess"));

      clearTokens();
      setPhoneNumber("");
      setVuaId("");

      replace(Routes.login);
    });
  };

  const { checkFingerprint } =
    useFingerprintValidation();

  useEffect(() => {
    checkFingerprint();
  }, [checkFingerprint]);

  return (
    <CommonLayout
      title={t(translation.lblResetPin)}
      showBackButton={true}
    >
      <div className="changePinPage">

        {/* =================================================
            PAGE INTRO
           ================================================= */}

        <div className="changePinIntro">

          <Typography.Text className="changePinSubtitle">
            {t("lblSetNewPinDescription")}
          </Typography.Text>

          <div className="changePinSecureBadge">
            <SafetyCertificateOutlined />
            <span>{t("lblYourInformationIsSecure")}</span>
          </div>

        </div>

        {/* =================================================
            MAIN CONTENT
           ================================================= */}

        <div className="changePinContent">

          {/* Security Illustration */}

          <div className="changePinIllustration">
            <div className="changePinIllustrationCircle">
              <img
                src={Change_Password_Header}
                alt={t("lblSecurityIllustration")}
              />
            </div>
          </div>

          {/* Form Card */}

          <section
            className="changePinFormCard"
            aria-labelledby="createPinHeading"
          >

            <div className="changePinFormHeading">

              <Typography.Title
                level={3}
                id="createPinHeading"
                className="changePinFormTitle"
              >
                {t("lblCreateNewPin")}
              </Typography.Title>

              <Typography.Text className="changePinFormSubtitle">
                {t("lblPinSecurityDescription")}
              </Typography.Text>

            </div>

            <Form
              form={form}
              name="resetPinForm"
              onFinish={formSubmit}
              autoComplete="off"
              layout="vertical"
              className="changePinForm"
              scrollToFirstError={true}
            >

              {/* =================================================
                  NEW PIN
                 ================================================= */}

              <Form.Item
                className="changePinFormItem"
                label={t("lblNewPin")}
              >
                <PinInput
                  className="changePasscodePin"
                  label={t("lblEnterPin")}
                  nameField="newPin"
                  customRule={checkNewPassword}
                  addonBefore={<LockOutlined />}
                  maxLength={6}
                  onChange={(pin) =>
                    setUpdatePin((old) => ({
                      ...old,
                      newPin: pin,
                    }))
                  }
                />

                <Typography.Text className="changePinFieldHint">
                  {t("lblPinMustBeSixDigits")}
                </Typography.Text>

              </Form.Item>

              {/* =================================================
                  CONFIRM PIN
                 ================================================= */}

              <Form.Item
                className="changePinFormItem"
                label={t("lblConfirmPin")}
              >
                <PinInput
                  className="changePasscodePin"
                  label={t("lblEnterPin")}
                  nameField="confirmNewPin"
                  customRule={checkConfirmPassword}
                  addonBefore={<LockOutlined />}
                  maxLength={6}
                  onChange={(pin) =>
                    setUpdatePin((old) => ({
                      ...old,
                      confirmNewPin: pin,
                    }))
                  }
                />
              </Form.Item>

              {/* =================================================
                  SUBMIT
                 ================================================= */}

              <div className="changePinActions">

                <Button
                  htmlType="submit"
                  className="changePinSubmitButton"
                >
                  <span>
                    {t("lblResetPin")}
                  </span>

                  <span className="changePinButtonArrow">
                    →
                  </span>
                </Button>

              </div>

            </Form>

          </section>

        </div>

      </div>
    </CommonLayout>
  );
};

export default ChangePassword;